import { useEffect } from 'react';
import { ngRoute } from '../../../app/routing/ngRoute';
import { getApiHost } from '../utils/getApiHost';
import { Model, switchExperience } from './switchExperience/switchExperience';

export interface ModernDashboardsRedirectProps {
    model: Model;
}

export function ModernDashboardsRedirect({ model }: ModernDashboardsRedirectProps): JSX.Element {
    useEffect(() => {
        if (ngRoute.history?.location.pathname.split('/').at(1) === 'dashboard') {
            void (async (): Promise<void> => {
                const response = await fetch(
                    new URL('/v2/directory/~migrate/status', getApiHost()),
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-SF-TOKEN': window.localStorage.getItem('X-SF-TOKEN') ?? '',
                        },
                    }
                );

                if (!response.ok) {
                    return;
                }

                try {
                    const json = (await response.json()) as {
                        data: { status: 'MIGRATED' | 'MIGRATING' | 'UNMIGRATED' };
                    };

                    if (json.data.status === 'MIGRATED') {
                        switchExperience(model);
                    }
                } catch {
                    // Do nothing
                }
            })();
        }
    }, [model]);

    return <></>;
}
